module.exports = __webpack_public_path__ + "static/media/android-icon.2e77d503.svg";